import { render, staticRenderFns } from "./StepsToFollow.vue?vue&type=template&id=abde5cd8&scoped=true&"
var script = {}
import style0 from "./StepsToFollow.vue?vue&type=style&index=0&id=abde5cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abde5cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abde5cd8')) {
      api.createRecord('abde5cd8', component.options)
    } else {
      api.reload('abde5cd8', component.options)
    }
    module.hot.accept("./StepsToFollow.vue?vue&type=template&id=abde5cd8&scoped=true&", function () {
      api.rerender('abde5cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ClubPriceInfo.vue/components/StepsToFollow.vue"
export default component.exports